export const GOPIXIE_ELEM_TAG_NAME = 'gopixie';
export const GOPIXIE_CONTAINER_ELEM_ID = 'gopixie-chat-container';
export const GOPIXIE_DRAWER_ELEM_ID = 'gopixie-chat-drawer';
export const PROD_SERVER_URL = 'https://gopixie.ai';
export const DEV_SERVER_URL = 'http://localhost:8000';
export const WEB_INTERACTION_WAIT_TIME = 500;
